import { IAgentSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { IState } from '../store';

export const selectAgent = (state: IState): IAgentSchema | null => state.offerData.agent;
